// GENERATED by make_beats.py — do not edit by hand.
// Times are force-aligned to the actual narration mp3.
export const DUR = 543.688;
export const SEG: {i:number;start:number;end:number}[] = [
  {i:0, start:0.3, end:6.765},
  {i:1, start:7.225, end:15.43},
  {i:2, start:15.951, end:29.28},
  {i:3, start:29.94, end:38.146},
  {i:4, start:38.706, end:42.869},
  {i:5, start:43.469, end:53.536},
  {i:6, start:54.137, end:60.781},
  {i:7, start:61.422, end:67.726},
  {i:8, start:68.186, end:77.833},
  {i:9, start:78.493, end:80.214},
  {i:10, start:80.655, end:85.798},
  {i:11, start:86.398, end:92.142},
  {i:12, start:92.683, end:101.168},
  {i:13, start:101.729, end:104.411},
  {i:14, start:104.971, end:115.418},
  {i:15, start:115.998, end:123.884},
  {i:16, start:124.504, end:131.789},
  {i:17, start:132.41, end:137.493},
  {i:18, start:137.853, end:146.839},
  {i:19, start:147.26, end:151.923},
  {i:20, start:152.483, end:160.288},
  {i:21, start:160.929, end:170.816},
  {i:22, start:171.396, end:178.681},
  {i:23, start:179.241, end:181.563},
  {i:24, start:182.103, end:187.647},
  {i:25, start:188.167, end:201.416},
  {i:26, start:202.017, end:208.681},
  {i:27, start:209.121, end:218.568},
  {i:28, start:219.228, end:239.802},
  {i:29, start:240.403, end:250.009},
  {i:30, start:250.609, end:266.86},
  {i:31, start:267.361, end:288.495},
  {i:32, start:288.755, end:292.538},
  {i:33, start:293.058, end:294.599},
  {i:34, start:295.1, end:308.008},
  {i:35, start:308.549, end:310.09},
  {i:36, start:310.65, end:321.137},
  {i:37, start:321.718, end:322.338},
  {i:38, start:322.898, end:333.125},
  {i:39, start:333.586, end:337.488},
  {i:40, start:337.929, end:355.28},
  {i:41, start:355.801, end:359.663},
  {i:42, start:360.184, end:362.425},
  {i:43, start:362.925, end:373.933},
  {i:44, start:374.513, end:382.599},
  {i:45, start:383.079, end:391.485},
  {i:46, start:392.145, end:394.947},
  {i:47, start:395.467, end:409.937},
  {i:48, start:410.418, end:433.913},
  {i:49, start:434.594, end:439.637},
  {i:50, start:440.298, end:454.207},
  {i:51, start:454.888, end:471.979},
  {i:52, start:472.66, end:483.007},
  {i:53, start:483.647, end:485.989},
  {i:54, start:486.409, end:495.875},
  {i:55, start:496.396, end:502.98},
  {i:56, start:503.46, end:515.669},
  {i:57, start:516.149, end:520.652},
  {i:58, start:521.012, end:532.4},
  {i:59, start:532.7, end:538.644},
  {i:60, start:539.225, end:542.227},
  {i:61, start:542.587, end:543.628},
];
export const PH: Record<string,[number,number,string]> = {
  hook: [10.687, 11.748, "आपका गोत्र क्या है"],
  setup: [21.254, 22.395, "प्रवर और सपिंड"],
  two: [35.324, 36.305, "दो अलग व्यवस्थाएँ"],
  arsha: [39.787, 40.347, "आर्ष गोत्र"],
  define: [49.674, 51.055, "एक रिषि पर जाकर रुकती है"],
  laukik: [62.482, 63.103, "लौकिक गोत्र"],
  surname: [87.319, 88.14, "सरनेम से अलग"],
  caste: [93.603, 94.404, "जाति से भी अलग"],
  seven: [106.392, 106.832, "सात रिषि"],
  agastya: [108.033, 108.934, "आठवें अगस्त्य"],
  counts: [129.408, 130.588, "हज़ारों, लाखों"],
  shakha: [145.298, 146.499, "पराशर और कौंडिन्य"],
  columns: [157.346, 160.288, "गोत्र, नख, निकास, पुरखा, और कुलदेवी"],
  kataria: [174.498, 175.198, "नख चौहान"],
  purkha: [180.682, 181.563, "नाम पुरखे का है"],
  pravar: [211.963, 212.864, "पहला, प्रवर"],
  bhishma: [257.854, 259.195, "वैयाघ्रपाद गोत्र वाले"],
  fortynine: [287.134, 288.495, "प्रवर उनचास गिनाता है"],
  diff: [290.196, 292.538, "गोत्र एक नाम है, प्रवर एक सूची है"],
  sapind: [300.944, 302.324, "पिता की तरफ़ सात पीढ़ी"],
  sankalpa: [319.456, 321.137, "गोत्र बोलना पूजा की शर्त थी"],
  three: [335.867, 337.488, "गोत्र, प्रवर, और सपिंड"],
  kane: [351.198, 352.578, "प्रवर चारों का एक ही है"],
  dnaclaim: [365.147, 366.668, "रिषियों को डीएनए का ज्ञान था"],
  charak: [380.017, 381.238, "अतुल्यगोत्रीय शारीर"],
  adharma: [387.662, 389.483, "समान गोत्र में संबंध अधर्म है"],
  risk: [402.272, 403.573, "एक से साढ़े तीन प्रतिशत"],
  maternal: [418.123, 419.604, "गोत्र मिलान में पास हो जाते हैं"],
  tests: [438.416, 439.637, "सपिंड ख़ून पकड़ता है"],
  ychrom: [446.862, 447.763, "वाई क्रोमोसोम"],
  legal: [458.13, 459.951, "सगोत्र विवाह भारत में वैध है"],
  lokachar: [482.106, 483.007, "यह लोकाचार है"],
  answer: [488.05, 488.57, "वही कहिए"],
  kashyap: [501.979, 502.56, "कश्यप गोत्र"],
  satyakam: [519.711, 520.652, "सच बोलने पर"],
  openq: [531.039, 532.4, "कमेंट बॉक्स में ज़रूर बताएँ"],
  cta: [536.523, 537.263, "व्हाट्सएप चैनल"],
  signoff: [542.587, 543.628, "हर हर महादेव"],
  o_janam: [0.841, 1.041, "जन्म"],
  o_mundan: [1.581, 1.961, "मुंडन"],
  o_shadi: [2.402, 2.682, "शादी"],
  o_griha: [3.282, 3.903, "गृह प्रवेश"],
  o_havan: [4.263, 4.523, "हवन"],
  o_antim: [5.944, 6.765, "अंतिम संस्कार"],
};
export const seg = (i:number) => SEG[i];
export const span = (a:number,b:number):[number,number] => [SEG[a].start, SEG[b].end];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
